module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create-shop":"Create Shop"},"th":{"create-shop":"สร้างร้านค้า"}}')
  delete Component.options._Ctor
}
